/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { repository } from '@whizz/api-client';
import { useQuery } from 'react-query';
import { ButtonIcon, Table } from '../../../../components';
import { GLOBAL_ICONS, QUERIES_IDS } from '../../../../util/vars';
import Input from '../../../../components/input/Input';
import Loader from '../../../../components/loader/Loader';

const SchoolsTable = ({ onClickEdit }: Props) => {
  const { translate: t } = useI18n();

  const [ search, setSearch ] = useState('');

  const getSchools = useQuery({
    queryKey: QUERIES_IDS.ADMIN.GET_SCHOOLS,
    queryFn: () => repository.AdminRepository.getSchools(),
  });

  function filteredSchools() {
    const schools = getSchools.data?.data ?? [];

    if (null == search || '' === search) {
      return schools;
    }

    const lowercasedSearch = search.toLowerCase();

    return schools
      .filter((school) => {
        const foundInName = school.school.name.toLowerCase().includes(lowercasedSearch);
        const foundInPostcode = school.school.postcode?.toLowerCase().includes(lowercasedSearch);

        return foundInName || foundInPostcode;
      })
    ;
  }

  if (getSchools.isLoading) {
    return (
      <Loader />
    );
  }

  return (
    <div className={'flex flex-col gap-5'}>
      <div>
        <Input
          id={'search'}
          label={'Search'}
          hideLabel
          placeholder={'Search school, town or postcode'}
          onChange={(event) => setSearch(event.target.value)}
          value={search}
        />
      </div>

      <div>
        <Table
          id={'weekly_leaders_emails'}
          cols={[
            {
              id: 'edit',
              Header: t('pages.ADMIN.TABLE.HEADERS.EDIT')!,
              accessor: 'school.id',
              Cell: (props) => (
                <ButtonIcon
                  icon={GLOBAL_ICONS.edit}
                  size={'sm'}
                  isOutline
                  onClick={() => onClickEdit(props.row.original.school.id)}
                />
              ),
              disableSortBy: true,
            },
            {
              id: 'id',
              Header: t('pages.ADMIN.TABLE.HEADERS.SCHOOL_ID')!,
              accessor: 'school.id',
            },
            {
              Header: t('pages.ADMIN.TABLE.HEADERS.SCHOOL_NAME')!,
              accessor: 'school.name',
            },
            {
              Header: t('pages.ADMIN.TABLE.HEADERS.SCHOOL_TOWN')!,
              accessor: 'school.city',
            },
            {
              Header: t('pages.ADMIN.TABLE.HEADERS.SCHOOL_POSTCODE')!,
              accessor: 'school.postcode',
            },
          ]}
          content={filteredSchools()}
          noDataMessage={t('pages.ADMIN.TABLE.NO_DATA')}
          initialState={{
            pageSize: 50,
          }}
        />
      </div>
    </div>
  );
};

interface Props {
  onClickEdit: (schoolId: number) => void;
}

export { SchoolsTable };

